import styled from "@emotion/styled";
import { GROW_WRAPPER_CLASS } from "../constants";
import { TextAreaStyledProps, getPadding } from "./TextAreaStyled";

interface GrowWrapperStyledProps
    extends Pick<
        TextAreaStyledProps,
        "validationState" | "isFocused" | "focusMode" | "themeMode" | "inputFieldHeight"
    > {
    children?: React.ReactNode;
}

export const GrowWrapperStyled = styled("div")<GrowWrapperStyledProps>`
    display: grid;
    position: relative;
    width: 100%;
    height: 100%;
    div.${GROW_WRAPPER_CLASS} {
        /* Hidden from view, clicks, and screen readers */
        visibility: hidden;
        padding: ${getPadding};
    }
`;
